export default function capitalize(str) {
  return (str && typeof str === 'string')
    ? str.split(' ')
      .map(s => (s && typeof s === 'string')
        ? s[0].toUpperCase() + s.substring(1)
        : '').join(' ')
    : ''
}
